import {PreloadImages} from '@/utils/image/types';

export * from './shared';

export const preloadImages: PreloadImages = (uris: string[]) => {
  uris.forEach(uri => {
    new Image().src = uri;
  });
};
